import gsap from "gsap";
import {
  BoxGeometry,
  Color,
  Group,
  Mesh,
  MeshBasicMaterial,
  MeshPhongMaterial,
  Object3d,
  Vector2,
  Vector3
} from 'three';
import {FBM, Perlin} from 'three-noise';

const animationStyles = {
  "pond" : {"style" : "znoise"},
  "water" : {"style" : "znoise"},
  "heron" : {},
  "snow" : {},
  "crow" : {},
  "branch" : {},
  "dream" : {"style" : "znoise"},
  "iris" : {},
  "morning glory" : {},
  "bucket" : {},
  "cemetery" : {},
  "fireflies" : {},
  "rains" : {},
  "pines" : {},
  "river" : {"style" : "znoise"},
  "snow" : {},
  "sword" : {},
  "night" : {"style" : "znoise"},
  "willows" : {},
  "stars" : {},
  "morning" : {"style" : "znoise"},
  "flowers" : {},
  "poppies" : {},
  "thunders" : {},
  "shadow" : {},
  "web" : {},
  "rose" : {},
  "leaves" : {},
  "fields" : {},
  "sing" : {},
  "earth" : {},
  "moon's" : {}
};

export default class LetterAnimations {

  constructor() { this.perlin = new Perlin(Math.random()); }

  startTimeLineAnimation(word, meshes) {
    // if (!animationStyles[word].hasOwnProperty('style')) {
    // start time animation
    this.tm = gsap.timeline({repeat : -1, repeatDelay : 8});
    let meshKeys = Object.keys(meshes);
    meshKeys.forEach((key) => {
      let mesh = meshes[key];
      let opos = mesh.position;
      let tm = gsap.timeline();
      tm.to(mesh.position,
            {y : opos.y + .01, duration : .5, 'ease' : "sine.inOut"});
      tm.to(mesh.scale, {x : 1.05, y : 1.05, z : 1.05, duration : .5}, "<");
      tm.to(mesh.position, {y : opos.y, duration : .5, 'ease' : "sine.inOut"});
      tm.to(mesh.scale, {x : 1, y : 1, z : 1, duration : .5}, "<");
      this.tm.add(tm, "<+=.1");
      // let tm2 = gsap.timeline({delay : 4});
      // tm2.to(mesh.rotation, {z : -.01, duration : .25, 'ease' :
      // "sine.inOut"}); tm2.to(mesh.rotation, {z : .01, duration : .25, 'ease'
      // : "sine.inOut"}); tm2.to(mesh.rotation, {z : 0, duration : .25, 'ease'
      // : "sine.inOut"}); this.tm.add(tm2, "<+=.1");
    });

    this.tm2 = gsap.timeline({repeat : -1, repeatDelay : 8, delay : 4});

    meshKeys.forEach((key) => {
      let mesh = meshes[key];
      let tm = gsap.timeline();
      tm.to(mesh.rotation, {z : -.025, duration : .25, 'ease' : "sine.inOut"});
      tm.to(mesh.rotation, {z : .025, duration : .25, 'ease' : "sine.inOut"});
      tm.to(mesh.rotation, {z : 0, duration : .25, 'ease' : "sine.inOut"});
      this.tm2.add(tm, "<+=.1");
    });
    // }
  }

  endTimeLineAnimation() {
    if (this.tm)
      this.tm.pause();
    if (this.tm2)
      this.tm2.pause();
  }

  animateLetters(t, meshes, key, word) {
    // console.log("animateLetters", meshes);

    if (word == "pond" || word == "dream" || word == "morning") {
      this.animateNoiseZ(t, meshes);
    }
  }

  // noise animation on z axis
  animateNoiseZ(t, meshes, timeScaleFactor = .25, noiseScaleFactor = .05) {
    let meshKeys = Object.keys(meshes);
    meshKeys.forEach((key) => {
      let mesh = meshes[key];
      if (!mesh.noiseSeed) {
        mesh.noiseSeed = Math.random();
        mesh.originPos = new Vector3().copy(mesh.position);
      }

      let ts = t * timeScaleFactor;
      let nz = this.perlin.get2(new Vector2(mesh.originPos.x * mesh.noiseSeed,
                                            ts + mesh.noiseSeed)) *
               noiseScaleFactor;
      mesh.position.set(mesh.originPos.x, mesh.originPos.y,
                        mesh.originPos.z + nz);
    });
  }
};
